import { createSelector, createSlice } from '@reduxjs/toolkit';

import { exportScribeDocument } from './actions/scribeDocumentActions';

const exportInitialState = {
  id: null,
  thumbnailUnpackStatus: null,
  exportedData: null
};

const INITIAL_STATE = {
  galleryItems: [],
  workspaceItems: [],
  exported: exportInitialState,
  isExporting: false,
  isLoading: false,
  isError: false,
  loadedAll: false,
  searchQuery: '',
  total: 0,
  totalOwned: 0,
  totalShared: 0
};

const scribeDocumentSlice = createSlice({
  name: 'scribeDocument',
  initialState: { ...INITIAL_STATE },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(exportScribeDocument.fulfilled, (state, action) => {
        state.exported = action.payload;
        state.isExporting = false;
        state.isError = false;
      })
      .addCase(exportScribeDocument.pending, (state) => {
        state.exported = exportInitialState;
        state.isExporting = true;
        state.isError = false;
      })
      .addCase(exportScribeDocument.rejected, (state) => {
        state.exported = exportInitialState;
        state.isExporting = false;
        state.isError = true;
      })
      .addCase('signOutGlobally', () => ({ ...INITIAL_STATE }));
  }
});

export const selectExport = createSelector(
  [
    (state) => state.scribeDocument.exported,
    (state) => state.scribeDocument.isExporting,
    (state) => state.scribeDocument.isError,
    (state) => state.scribeDocument.loadedAll
  ],
  (exported, isExporting, isError, loadedAll) => ({ exported, isExporting, isError, loadedAll })
);

export default scribeDocumentSlice.reducer;
